/**
 * @prettier
 */
import { PrinterType, PrinterTypes } from 'src/constants/PrinterType';

export function isPaymentTerminalPrinter(printerType: PrinterType): boolean {
    return printerType === PrinterTypes.PAYMENT_TERMINAL_PRINTER;
}
